import { AmountOffCouponBase } from '../amount-off/amount-off-base';
import { CategoryBaseTriggerItemsQualifier } from "../../coupon-qualifiers/trigger-items/category-base-trigger-items";
export class PercentOffAnItemInCategoryCoupon extends AmountOffCouponBase {
    constructor(appType, sourceData, deps, baseData, identity) {
        super(appType, sourceData, deps, baseData, identity);
        this._preQualifiers.push(new CategoryBaseTriggerItemsQualifier(this._data, true));
    }
    getDiscountItems(cart) {
        return this._getDiscountItemsFromTriggers(cart);
    }
    /**
     * The percentage comes off the QUALIFIED ITEM, not the order. Matches legacy
     * POS: `totalAmounts.OrderItemPrice * coupon.Discount / 100` for
     * Percentage_Off_Item_In_Category_Or_BOGO_In_Category.
     */
    computeDiscountAmount(totalAmounts, cart) {
        const amt = totalAmounts.orderItemPrice * this._discountAmount / 100;
        return this._adjustDiscountAmount(cart, amt);
    }
}
//# sourceMappingURL=percent-off-an-item-in-category.js.map